export default [
    {
        path: '',
        name: 'pageDirectionRouter',
        component: () => import('./page-direction')
    }
]